// src/pages/Group.js

import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc, collection, getDocs, query, where } from 'firebase/firestore';

const Group = () => {
  const { groupId } = useParams();
  const [groupData, setGroupData] = useState(null);
  const [members, setMembers] = useState([]);

  useEffect(() => {
    const fetchGroupData = async () => {
      try {
        const groupDoc = await getDoc(doc(db, 'groups', groupId));
        if (groupDoc.exists()) {
          const data = groupDoc.data();
          setGroupData(data);

          // Fetch member details
          const membersQuery = query(
            collection(db, 'users'),
            where('email', 'in', data.users)
          );
          const memberDocs = await getDocs(membersQuery);
          const membersData = memberDocs.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
          setMembers(membersData);
        }
      } catch (error) {
        console.error('Error fetching group data:', error);
      }
    };

    fetchGroupData();
  }, [groupId]);

  if (!groupData) {
    return <p className="text-center mt-8 text-gray-500">Loading group information...</p>;
  }

  return (
    <div>
      <div className="container mx-auto mt-8 p-8 bg-white shadow-md rounded-lg">
        <h1 className="text-3xl font-bold text-primary mb-4">{groupData.name}</h1>
        <p className="text-gray-600 text-lg mb-6">
          Group ID: <span className="font-semibold">{groupId}</span>
        </p>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">Members</h2>
        <div className="bg-gray-100 p-4 rounded-lg">
          {members.length > 0 ? (
            <ul>
              {members.map((member) => (
                <li key={member.id} className="mb-4">
                  <Link
                    to={`/user/${member.id}`}
                    className="text-lg font-medium text-indigo-600 hover:underline"
                  >
                    {member.name || member.email}
                  </Link>
                  <p className="text-sm text-gray-500">Status: {member.status}</p>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500">No members in this group.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Group;
